export function getApiBaseUrl(): string {
  const value = window.APP_CONFIG?.API_URL ?? import.meta.env.VITE_API_URL ?? '/api/v1';
  return value.replace(/\/+$/, '');
}

export function getBackendOrigin(): string {
  const apiUrl = window.APP_CONFIG?.API_URL ?? import.meta.env.VITE_API_URL ?? 'http://localhost:4025/api/v1';
  try {
    return new URL(apiUrl).origin;
  } catch {
    return 'http://localhost:4025';
  }
}

export function getSsoOrigin(): string {
  return (window.APP_CONFIG?.SSO_URL ?? import.meta.env.VITE_SSO_URL ?? 'http://localhost:4080').replace(/\/+$/, '');
}
